import { baseUniDriverFactory as testUtilsBaseUniDriverFactory } from '@wix/wix-ui-test-utils/base-driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export function baseUniDriverFactory(base: UniDriver) {
  const driver = testUtilsBaseUniDriverFactory(base);
  return {
    exists: () => driver.exists(),
    click: () => driver.click(),
    element: () => driver.element(),
  };
}
